import { useContext } from 'react'

import { Context, type Locale } from '../../providers/Intl'
import en from '../../resources/intl/countries.en.json'
import uk from '../../resources/intl/countries.uk.json'

const countries: Record<Locale, { [key: string]: string }> = { en, uk }

function useCountries() {
  const { locale } = useContext(Context)

  return {
    getIsoByName: (name?: string) =>
      name
        ? (Object.entries(countries[locale])
            .find(([, countryName]) => countryName === name)?.[0]
            .toUpperCase() ?? '')
        : '',
    getNameByIso: (iso?: string) => (iso ? countries?.[locale][iso.toUpperCase()] : ''),
    countries: countries[locale],
  }
}

export { useCountries }
